import { SignInWrapperProps } from 'types';
import { SignWrapper } from './SignWrapper';

export const SignUpWrapper = ({ slides, footer, children }: SignInWrapperProps) => {
  return (
    <SignWrapper
      slides={slides}
      HeaderLinkDescription="Already have an account?"
      headerLinkCaption="Sign In"
      headerLink="/sign-in"
      linkId="sign-up-wrapper-sign-in"
      footer={footer}
    >
      {children && children}
    </SignWrapper>
  );
};
